export const PenaltyStrokeGoalKeeperChange = {
  name: "penalty-change-goal-keeper",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "changeGoalkeeper",
  showOn: [{ state: "primary", value: "penalty-stroke-goalkeeper-select", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  showDetails: { events: ["main"] },
  children: [
    {
      name: "penalty-stroke-goalkeeper-select-panel",
      component: "ChangeGoalkeeper",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: false,
        selectOnly: true,
        addGoalkeeperIdToEvent: "main",
        sendGoalKeeperChangeEvent: false,
        showAllPlayers: true,
      },
      actionGroups: [
        {
          actions: [
            { action: "copyData", type: "penalty", value: "personId" },
            { action: "saveData", value: "penaltyStroke", type: "eventType" },
            {
              action: "nextState",
              value: "penalty-stroke-outcome-select",
              type: "primary",
            },
          ],
        },
      ],
    },
  ],
};
